import { useState } from "react";
import { Link } from "react-router-dom";
import { TEAM_STORIES } from "../data/teamStories";
import useInteract3D from "../hooks/useInteract3D";
import "./SuccessStories.css";

function TeamPortrait({ story }) {
  const { tiltRef, popping } = useInteract3D(14, Boolean(story.interactive3D));

  const imageStyle = story.imagePosition
    ? { objectPosition: story.imagePosition }
    : undefined;

  const image = (
    <img
      src={story.image}
      alt={story.name}
      style={imageStyle}
      className={`team-portrait-img team-portrait-img--${story.slug}`}
    />
  );

  if (!story.interactive3D) {
    return (
      <div className="success-stories-image">
        <div className="team-portrait-frame">{image}</div>
      </div>
    );
  }

  return (
    <div className="success-stories-image">
      <button
        type="button"
        ref={tiltRef}
        className={`team-portrait-3d ${popping ? "team-portrait-3d--pop" : ""}`}
        aria-label={`${story.name} — tap for 3D effect`}
      >
        <span className="team-portrait-glow" aria-hidden="true" />
        <span className="team-portrait-frame">{image}</span>
        <span className="team-portrait-hint" aria-hidden="true">
          Tap me
        </span>
      </button>
    </div>
  );
}

export default function SuccessStories() {
  const [active, setActive] = useState(0);
  const story = TEAM_STORIES[active];

  const goPrev = () =>
    setActive((i) => (i === 0 ? TEAM_STORIES.length - 1 : i - 1));
  const goNext = () =>
    setActive((i) => (i === TEAM_STORIES.length - 1 ? 0 : i + 1));

  return (
    <section className="success-stories" id="team">
      <div className="container">
        <h2 className="success-stories-heading">Meet the Maskanh team</h2>

        <div className="success-stories-slide">
          <div className="success-stories-text">
            <blockquote className="success-quote">
              &ldquo;{story.quote}&rdquo;
            </blockquote>
            <p className="success-name">{story.name}</p>
            <p className="success-role">
              {story.role}, {story.company}
            </p>
            <Link
              to={`/team/${story.slug}`}
              className="success-story-link"
            >
              {story.linkLabel || "Read Our Story"} →
            </Link>

            <div className="success-nav">
              <button
                type="button"
                className="success-nav-btn"
                onClick={goPrev}
                aria-label="Previous story"
              >
                ‹
              </button>
              <button
                type="button"
                className="success-nav-btn"
                onClick={goNext}
                aria-label="Next story"
              >
                ›
              </button>
            </div>
          </div>

          <TeamPortrait key={story.slug} story={story} />
        </div>

        <div className="success-dots">
          {TEAM_STORIES.map((s, i) => (
            <button
              key={s.slug}
              type="button"
              className={`success-dot ${i === active ? "active" : ""}`}
              onClick={() => setActive(i)}
              aria-label={`View ${s.name}'s story`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
